var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('load-more',{attrs:{"data-source":_vm.evaluateList,"total":_vm.total,"loading":_vm.loading},on:{"load-more":_vm.onLoad}},[_c('AppraiseItem',{attrs:{"evaluate-list":_vm.evaluateList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }